import styled from 'styled-components';

export const Iframe = styled.iframe`
    border: none;
    border-radius: 0.5rem;
    overflow: hidden;
`;
